/* eslint-disable sort-keys */

import React from 'react'
import Action from './action'

const actionColumn = {
  key: 'action',
  render: site => {
    const action = <Action site={site} />
    return action
  },
  title: 'Actions',
  width: 150
}

const nameColumn = {
  dataIndex: 'site_name',
  key: 'name',
  sorter: (a, b) => a.name.localeCompare(b.name),
  title: 'Site Name'
}

// const createdColumn = {
//   align: 'right',
//   dataIndex: 'created',
//   key: 'created',
//   sorter: (a, b) => a.created > b.created,
//   title: 'Tag Created',
//   width: 175
// }

export const tagColumns = {
  action: actionColumn,
  name: nameColumn
  // created: createdColumn
}
